export default __webpack_public_path__ + "static/media/pimeo-logo-w.2656db78.png";